@if (show()) {
  <div class="duty-review-banner" role="status">
    <div class="duty-review-banner__icon" aria-hidden="true">
      <img src="/public/svgs/bell.svg" alt="" width="18" height="18" />
    </div>

    <p class="duty-review-banner__text">
      {{ messageKey() | translate: messageParams() }}
    </p>

    <div class="duty-review-banner__actions">
      <a
        routerLink="/home/assignments"
        class="duty-review-banner__cta"
      >
        {{ 'app.parentLayout.dutyReviewBanner.cta' | translate }}
      </a>
      <button
        type="button"
        class="duty-review-banner__dismiss"
        (click)="dismiss()"
        [attr.aria-label]="'app.parentLayout.dutyReviewBanner.dismissAria' | translate"
      >
        {{ 'app.parentLayout.dutyReviewBanner.dismiss' | translate }}
      </button>
    </div>
  </div>
}
